<template lang="pug">
  router-view
</template>

<script>
import { EventBus } from '@/library/_event-bus.js';
import { initTheme } from '@/utils/theme.js';

export default {
  name: 'App',
  components: {},
  computed: {
    whiteLabel() {
      return this.$store.getters.whiteLabel;
    },
    theme() {
      return this.$store.getters.whiteLabel.theme;
    }
  },
  watch: {
    theme(newVal, oldVal) {
      if (this.whiteLabel.mode && this.whiteLabel.theme) {
        $('body').removeClass(oldVal);
        $('body').addClass(newVal);
      }
    }
  },
  mounted() {
    initTheme();
    if (this.whiteLabel.mode && this.whiteLabel.theme) {
      $('body').addClass(this.whiteLabel.theme);
    }
  }
};
</script>

<style lang="scss">
@import './assets/app.scss';
</style>
